// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * 개발버전 배지 — 우하단 반투명 빨강(bridge-app 의 tv_env_badge 와 톤 일치).
 * build-version(v.{timestamp}, bottom:4px) 바로 위에 얹어 겹치지 않게 bottom:22px.
 */
.dev-env-badge {
  position: fixed;
  bottom: 22px;
  right: 8px;
  z-index: 99999;
  padding: 2px 10px;
  border-radius: 999px;
  background: rgba(220, 38, 38, 0.62);
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.5px;
  line-height: 1.5;
  pointer-events: none;   /* 조작 방해 금지(빌드버전과 동일) */
  -webkit-user-select: none;
          user-select: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/DevEnvBadge.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;EACE,eAAe;EACf,YAAY;EACZ,UAAU;EACV,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,mCAAmC;EACnC,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB,IAAI,uBAAuB;EAC/C,yBAAiB;UAAjB,iBAAiB;AACnB","sourcesContent":["/**\n * 개발버전 배지 — 우하단 반투명 빨강(bridge-app 의 tv_env_badge 와 톤 일치).\n * build-version(v.{timestamp}, bottom:4px) 바로 위에 얹어 겹치지 않게 bottom:22px.\n */\n.dev-env-badge {\n  position: fixed;\n  bottom: 22px;\n  right: 8px;\n  z-index: 99999;\n  padding: 2px 10px;\n  border-radius: 999px;\n  background: rgba(220, 38, 38, 0.62);\n  color: #fff;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.5px;\n  line-height: 1.5;\n  pointer-events: none;   /* 조작 방해 금지(빌드버전과 동일) */\n  user-select: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
